// [APP_STORE_URL] — PLACEHOLDER: swap this single constant with the official App Store listing URL at launch.
export const APP_STORE_URL = "https://apps.apple.com/app/five-star-concierge-dating";

export const EMAILS = {
  hello: "hello@meetfivestar.app",
  support: "support@meetfivestar.app",
  privacy: "privacy@meetfivestar.app",
};

export const NAV_LINKS = [
  { to: "/nasil-calisir", label: "Nasıl Çalışır", testid: "nav-link-nasil-calisir" },
  { to: "/the-five", label: "The Five", testid: "nav-link-the-five" },
  { to: "/uyelik", label: "Üyelik", testid: "nav-link-uyelik" },
  { to: "/sss", label: "SSS", testid: "nav-link-sss" },
  { to: "/support", label: "Destek", testid: "nav-link-destek" },
];

const u = (id, w = 800) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  cafe: u("1521017432531-fbd92d768814", 1200),
  dinner: u("1414235077428-338989a2e8c0", 1400),
  cocktails: u("1470337458703-46ad1756a187", 1200),
  interior: u("1517248135467-4c7edcad34c4", 1400),
  coffee: u("1445116572660-236099ec97a0", 1200),
  toast: u("1511632765486-a01980e01a18", 1200),
  city: u("1519501025264-65ba15a82390", 1400),
  editorial: u("1469334031218-e382a71b716b", 1000),
};

// Temsili (kurgusal) tanıtım profilleri — gerçek kullanıcı verisi değildir.
export const PROFILES = [
  { name: "Elif", age: 29, city: "İstanbul", tag: "Sanat & Tasarım", img: "/profiles/elif.jpg" },
  { name: "Mert", age: 32, city: "İstanbul", tag: "Gastronomi", img: "/profiles/mert.jpg" },
  { name: "Zeynep", age: 27, city: "İzmir", tag: "Edebiyat", img: "/profiles/zeynep.jpg" },
  { name: "Kaan", age: 31, city: "Ankara", tag: "Mimarlık", img: "/profiles/kaan.jpg" },
  { name: "Selin", age: 30, city: "İstanbul", tag: "Caz & Şarap", img: "/profiles/selin.jpg" },
];
